import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FastBackwardFilledSvg from "@ant-design/icons-svg/es/asn/FastBackwardFilled";
import AntdIcon from "../components/AntdIcon";
var FastBackwardFilled = function FastBackwardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FastBackwardFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FastBackwardFilled.displayName = 'FastBackwardFilled';
}
export default /*#__PURE__*/React.forwardRef(FastBackwardFilled);